import { Box, Grid, Paper, Typography } from "@mui/material"
import { utils } from "../../../utils/utils";
import SellerSales from "./sellerSales";
import InvoiceSummary from "./invoiceSummary";
import PaymentMethodSummary from './paymentMethodSummary';

// Hooks
import useCashRegister from "../../../hooks/cashRegisters/useCashRegister";

const CashRegisterViewTotal = () => {
    const { cashRegister } = useCashRegister();

    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <Box component={Paper} padding={2} display='flex' flexDirection='column' gap={1}>
                    <Typography variant='h4'>
                        {`Consulta de caja: ${cashRegister?.name}`}
                    </Typography>
                    <Typography variant='h6'>
                        {`Fecha: ${utils.formatDate(cashRegister?.lastClosure)} - ${utils.formatDate(new Date())}`}
                    </Typography>
                </Box>
            </Grid>
            <Grid size={12}>
                <Box component={Paper} padding={2}>
                    <SellerSales />
                </Box>
            </Grid>
            <Grid size={12}>
                <Box component={Paper} padding={2}>
                    <PaymentMethodSummary />
                </Box>
            </Grid>
            <Grid size={12}>
                <Box component={Paper} padding={2}>
                    <InvoiceSummary />
                </Box>
            </Grid>
        </Grid>
    );
}

export default CashRegisterViewTotal;